import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimStatusAuditLog.List.IRequest;
type Response = Api.Core.ClaimStatusAuditLog.List.IResponse;
type Headers = Api.Core.ClaimStatusAuditLog.List.IHeaders;
const url = '/api/Claims/ClaimStatusAuditLog';
export default async function claimStatusAuditLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
